<template>
  <van-popup v-model="kaiguan" :style="{background:'transparent'}" :close-on-click-overlay="false">
    <div class="alert" v-if="msg.type === 'DJQ'">
      <p class="title mb4">恭喜获得</p>
      <p class="msg mb4">{{msg.prize}}</p>
      <!-- <p class="msg mb4">在游戏内支付时即可使用！</p> -->
      <van-button
        type="primary"
        size="large"
        color="linear-gradient(to bottom, #e28215,#dc580d)"
        class="btn"
        @click="closeAlert"
      >我知道了</van-button>
    </div>
    <div class="alert" v-else-if="msg.type === 'NONE'">
      <p class="title mb4">{{msg.prize}}</p>
      <van-button
        type="primary"
        size="large"
        color="linear-gradient(to bottom, #e28215,#dc580d)"
        class="btn"
        @click="closeAlert"
      >确定</van-button>
    </div>
    <div class="alert" v-else>
      <p class="title mb4">恭喜获得</p>
      <p class="msg mb4">{{msg.prize}}</p>
      <van-button
        type="primary"
        size="large"
        color="linear-gradient(to bottom, #e28215,#dc580d)"
        class="btn"
        @click="closeAlert"
      >确定</van-button>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: "alert",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    msg: {
      type: Object,
      default: function() {
        return {
          type: ""
        };
      }
    }
  },
  computed: {
    kaiguan: {
      get: function() {
        return this.show;
      },
      set: function() {
        return;
      }
    }
  },
  methods:{
    closeAlert(){
      this.$parent.open('msgAlert')
      this.$emit('change-alert')
    }
  }
};
</script>

<style scoped lang="scss">
.alert {
  width: 745px;
  padding: 50px;
  background: rgba(255, 255, 255, 1);
  border: 0.1rem solid rgba(255, 255, 255, 1);
  box-shadow: inset 0px 3px 21px 0px rgba(244, 160, 68, 0.78);
  border-radius: 30px;
  text-align: center;
  font-size: 45px;
  .mb4 {
    margin-bottom: 35px;
  }
  .btn {
    cursor: pointer;
    height: 100px;
    line-height: 100px;
    font-size: 35px;
    border-radius: 50px;
  }
  .msg {
    font-size: 50px;
  }
}
</style>